module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"cause":{"damp":"湿潤","garbage":"腐食","waterbody":"水系","green_space":"緑地","stored_food":"食品","mold":"菌"},"route":{"indoor":"内部発生","outdoor":"外部侵入"}},"en":{"cause":{"damp":"Damp","garbage":"Garbage","waterbody":"Waterbody","green_space":"Green space","stored_food":"Stored food","mold":"Mold"},"route":{"indoor":"Indoor","outdoor":"Outdoor"}}}')
  delete Component.options._Ctor
}
